import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'resultsHeader'
})
export class ResultsHeaderPipe implements PipeTransform {
  transform(value: any[], header: boolean): any {
    if (header) {
      return value?.filter(a => a.header) || [];
    } else {
      return value?.filter(a => !a.header) || [];
    }
  }
}
